(function () {
var $e27b66a2e97b0703$var$$ = jQuery;
var $e27b66a2e97b0703$var$_window = $e27b66a2e97b0703$var$$(window);
var $e27b66a2e97b0703$var$Menu = {
    $dom: {
        container: $e27b66a2e97b0703$var$$("#site-navigation"),
        menu_toggle: $e27b66a2e97b0703$var$$(".menu-toggle"),
        body: $e27b66a2e97b0703$var$$("body"),
        menu: undefined,
        links: undefined,
        sub_menus: undefined
    },
    vars: {
        activated_screen_resolution: 1199,
        show_arrows_on_desktop: false
    },
    initDom: function initDom() {
        $e27b66a2e97b0703$var$Menu.$dom.menu = $e27b66a2e97b0703$var$Menu.$dom.container.find("ul").eq(0);
        $e27b66a2e97b0703$var$Menu.$dom.links = $e27b66a2e97b0703$var$Menu.$dom.menu.find("a");
        $e27b66a2e97b0703$var$Menu.$dom.sub_menus = $e27b66a2e97b0703$var$Menu.$dom.menu.find("ul");
    },
    appendArrows: function appendArrows() {
        if ($e27b66a2e97b0703$var$_window.width() <= $e27b66a2e97b0703$var$Menu.vars.activated_screen_resolution || $e27b66a2e97b0703$var$Menu.vars.show_arrows_on_desktop) {
            var items_has_children = $e27b66a2e97b0703$var$Menu.$dom.container.find("li.menu-item-has-children");
            items_has_children.each(function() {
                if ($e27b66a2e97b0703$var$$(this).find(".arrow-toggle").length > 0) return;
                var $parent = this;
                var $arrow = $e27b66a2e97b0703$var$$("<span class='arrow-toggle'><span class='arrow-toggle--icon'></span></span>");
                $e27b66a2e97b0703$var$$(this).prepend($arrow);
                $arrow.on("click", function() {
                    $e27b66a2e97b0703$var$$($parent).toggleClass("expandeds");
                    $e27b66a2e97b0703$var$$($parent).find("> .sub-menu").slideToggle(500);
                });
            });
        } else $e27b66a2e97b0703$var$$(".arrow-toggle").remove();
    },
    toggleMenu: function toggleMenu() {
        $e27b66a2e97b0703$var$Menu.$dom.menu_toggle.on("click", function(e) {
            $e27b66a2e97b0703$var$Menu.$dom.menu_toggle.toggleClass("is-active");
            $e27b66a2e97b0703$var$Menu.$dom.body.toggleClass("menu-active");
            $e27b66a2e97b0703$var$Menu.$dom.container.toggleClass("toggled");
            e.stopPropagation();
        });
    },
    closeMenu: function closeMenu() {
        if ($e27b66a2e97b0703$var$$(this).attr("href") != "#" && $e27b66a2e97b0703$var$$(this).attr("href") != "") {
            $e27b66a2e97b0703$var$Menu.$dom.body.removeClass("menu-active");
            $e27b66a2e97b0703$var$Menu.$dom.menu_toggle.removeClass("is-active");
            $e27b66a2e97b0703$var$Menu.$dom.container.removeClass("toggled");
        }
    },
    bindScrollResize: function bindScrollResize() {
        $e27b66a2e97b0703$var$_window.on("resize", function() {
            $e27b66a2e97b0703$var$Menu.appendArrows();
        });
    },
    bindClicks: function bindClicks() {
        $e27b66a2e97b0703$var$$(document).on("click", $e27b66a2e97b0703$var$Menu.closeMenu);
        $e27b66a2e97b0703$var$Menu.$dom.links.on("click", $e27b66a2e97b0703$var$Menu.closeMenu);
        $e27b66a2e97b0703$var$Menu.toggleMenu();
        $e27b66a2e97b0703$var$Menu.$dom.container.find("> div").click(function(e) {
            e.stopPropagation();
        });
    },
    init: function init() {
        $e27b66a2e97b0703$var$Menu.initDom();
        $e27b66a2e97b0703$var$Menu.appendArrows();
        $e27b66a2e97b0703$var$Menu.bindClicks();
        $e27b66a2e97b0703$var$Menu.bindScrollResize();
    }
};
var $e27b66a2e97b0703$export$2e2bcd8739ae039 = $e27b66a2e97b0703$var$Menu;


var $ebcfa5bf42516135$var$$ = jQuery;
var $ebcfa5bf42516135$var$Theme = {
    dom: {
        shareLink: $ebcfa5bf42516135$var$$(".share-buttons a"),
        smoothScrollLinks: $ebcfa5bf42516135$var$$('a[href*="#"]')
    },
    /**************************************************
    * Share links
    **************************************************/ share: function share() {
        $ebcfa5bf42516135$var$$(".share-buttons a").on("click", function(e) {
            if (!$ebcfa5bf42516135$var$$(this).hasClass("btn-email")) {
                e.preventDefault();
                $ebcfa5bf42516135$var$Theme.PopupCenter($ebcfa5bf42516135$var$$(this).attr("href"), $ebcfa5bf42516135$var$$(this).attr("title"), 500, 300);
            }
        });
    },
    /**************************************************
    * Share links popup
    **************************************************/ PopupCenter: function PopupCenter(url, title, w, h) {
        // Fixes dual-screen position                         Most browsers      Firefox
        var dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : screen.left;
        var dualScreenTop = window.screenTop != undefined ? window.screenTop : screen.top;
        var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
        var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;
        var left = width / 2 - w / 2 + dualScreenLeft;
        var top = height / 2 - h / 2 + dualScreenTop;
        var newWindow = window.open(url, title, "scrollbars=yes, width=" + w + ", height=" + h + ", top=" + top + ", left=" + left);
        // Puts focus on the newWindow
        if (window.focus) newWindow.focus();
    },
    /**************************************************
    * Smooth scroll
    ***************************************************/ smooth_scroll: function smooth_scroll() {
        $ebcfa5bf42516135$var$Theme.dom.smoothScrollLinks// Remove links that don't actually link to anything
        .not('[href="#"]').not('[href="#0"]').click(function(event) {
            // On-page links
            if (location.pathname.replace(/^\//, "") == this.pathname.replace(/^\//, "") && location.hostname == this.hostname) {
                // Figure out element to scroll to
                var target = $ebcfa5bf42516135$var$$(this.hash);
                target = target.length ? target : $ebcfa5bf42516135$var$$("[name=" + this.hash.slice(1) + "]");
                // Does a scroll target exist?
                if (target.length) {
                    // Only prevent default if animation is actually gonna happen
                    event.preventDefault();
                    $ebcfa5bf42516135$var$$("html, body").animate({
                        scrollTop: target.offset().top
                    }, 1000, function() {
                        // Callback after animation
                        // Must change focus!
                        var $target = $ebcfa5bf42516135$var$$(target);
                        $target.focus();
                        if ($target.is(":focus")) // Checking if the target was focused
                        return false;
                        else {
                            $target.attr("tabindex", "-1"); // Adding tabindex for elements not focusable
                            $target.focus(); // Set focus again
                        }
                    });
                }
            }
        });
    },
    /**************************************************
    * Fix Height on smaller devices
    **************************************************/ fix_mobile_height: function fix_mobile_height() {
        var vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty("--vh", "".concat(vh, "px"));
        window.addEventListener("resize", function() {
            var vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty("--vh", "".concat(vh, "px"));
        });
    },
    /**************************************************
    * Initial all theme functions
    **************************************************/ init: function init() {
        $ebcfa5bf42516135$var$Theme.share();
        $ebcfa5bf42516135$var$Theme.smooth_scroll();
        $ebcfa5bf42516135$var$Theme.fix_mobile_height();
    }
};
var $ebcfa5bf42516135$export$2e2bcd8739ae039 = $ebcfa5bf42516135$var$Theme;


var $8abcc1088efdfbad$var$$ = jQuery;
var $8abcc1088efdfbad$var$Exapnd = {
    init: function init() {
        var buttonEl = document.querySelector(".more-details");
        if (buttonEl) buttonEl.addEventListener("click", function() {
            console.log("click");
            buttonEl.classList.toggle("active");
        });
    }
};
var $8abcc1088efdfbad$export$2e2bcd8739ae039 = $8abcc1088efdfbad$var$Exapnd;


var $5212bc5a3ed6c991$var$$ = jQuery;
var $5212bc5a3ed6c991$var$Filter = {
    init: function init() {
        var headerEl = document.querySelectorAll(".wpc-filter-header");
        headerEl.forEach(function(el) {
            el.addEventListener("click", function() {
                var nextEl = el.nextElementSibling;
                headerEl.forEach(function(otherEl) {
                    if (otherEl !== el) otherEl.nextElementSibling.classList.remove("active");
                });
                nextEl.classList.toggle("active");
            });
        });
    }
};
var $5212bc5a3ed6c991$export$2e2bcd8739ae039 = $5212bc5a3ed6c991$var$Filter;


var $1c60fdd7aa1191e5$var$$ = jQuery;
var $1c60fdd7aa1191e5$var$AboutBook = {
    init: function init() {
        var titleEl = document.querySelectorAll(".product-specification--title .more-info-book");
        var content = document.querySelectorAll(".product-specification--content > div");
        if (titleEl) titleEl.forEach(function(el, i) {
            el.addEventListener("click", function() {
                openContent(i);
                titleEl.forEach(function(element) {
                    element.classList.remove("active");
                });
                el.classList.add("active");
            });
        });
        function openContent() {
            var index = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
            content.forEach(function(el, i) {
                if (index === i) el.classList.add("active");
                else el.classList.remove("active");
            });
        }
    }
};
var $1c60fdd7aa1191e5$export$2e2bcd8739ae039 = $1c60fdd7aa1191e5$var$AboutBook;


var $3bf4470344899cf3$var$$ = jQuery;
var $3bf4470344899cf3$var$Slick = {
    init: function init() {
        $3bf4470344899cf3$var$$(".slider-for").slick({
            slidesToShow: 6,
            slidesToScroll: 1,
            arrows: false,
            fade: false,
            draggable: true,
            responsive: [
                {
                    breakpoint: 1280,
                    settings: {
                        slidesToShow: 5,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 1199,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 575,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 420,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });
        $3bf4470344899cf3$var$$(".slider-for").on("afterChange", function(event, slick, currentSlide, nextSlide) {
            progressBar(currentSlide, false);
        });
        function progressBar() {
            var index = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, loaded = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
            var _$progressBar = $3bf4470344899cf3$var$$(".progress-bar__inner");
            var itemWidth = 100 / parseInt($3bf4470344899cf3$var$$(".slider-for").data("count"));
            var progress = (index + 1) * itemWidth;
            _$progressBar.css("width", progress + "%");
            if (loaded) $3bf4470344899cf3$var$$(".slider-for").slick("slickGoTo", index);
        }
        progressBar();
        $3bf4470344899cf3$var$$(".progress-bar").on("click", function(event) {
            var barWidth = $3bf4470344899cf3$var$$(this).width();
            var clickX = event.pageX - $3bf4470344899cf3$var$$(this).offset().left;
            var index = Math.floor(clickX / barWidth * parseInt($3bf4470344899cf3$var$$(".slider-for").data("count")));
            progressBar(index);
        });
    }
};
var $3bf4470344899cf3$export$2e2bcd8739ae039 = $3bf4470344899cf3$var$Slick;


var $80ac2f7228d39a43$var$$ = jQuery;
var $80ac2f7228d39a43$var$InputNumber = {
    var: {
        min: 0,
        max: null,
        step: 1
    },
    dom: {
        inputs: $80ac2f7228d39a43$var$$('input[type="number"]')
    },
    increase: function($input) {
        var currentVal = parseFloat($input.val());
        var newValue = currentVal + $80ac2f7228d39a43$var$InputNumber.var.step;
        if ($80ac2f7228d39a43$var$InputNumber.var.max != null && newValue <= $80ac2f7228d39a43$var$InputNumber.var.max || $80ac2f7228d39a43$var$InputNumber.var.max == null) {
            $input.val(newValue);
            $input.trigger("change");
        }
    },
    decrease: function($input) {
        var currentVal = parseFloat($input.val());
        var newValue = currentVal - $80ac2f7228d39a43$var$InputNumber.var.step;
        if ($80ac2f7228d39a43$var$InputNumber.var.min <= newValue) {
            $input.val(newValue);
            $input.trigger("change");
        }
    },
    makeDom: function() {
        var _loop = function(index) {
            var $inputWrapper = $80ac2f7228d39a43$var$$('<div class="input-wrapper" />');
            var $this = $80ac2f7228d39a43$var$$($80ac2f7228d39a43$var$$('input[type="number"]')[index]);
            var $plus = void 0, $minus = void 0;
            if ($this.closest(".shop-pages").length > 0) {
                $plus = $80ac2f7228d39a43$var$$('<span class="arrow-up icon">+</span>');
                $minus = $80ac2f7228d39a43$var$$('<span class="arrow-down icon">-</span>');
            } else {
                $plus = $80ac2f7228d39a43$var$$("<div class=plus>+</div>");
                $minus = $80ac2f7228d39a43$var$$("<div class=minus>-</div>");
            }
            if ($this.attr("min") && $this.attr("min") !== "") $80ac2f7228d39a43$var$InputNumber.var.min = parseFloat($this.attr("min"));
            if ($this.attr("max") && $this.attr("max") !== "") $80ac2f7228d39a43$var$InputNumber.var.max = parseFloat($this.attr("max"));
            if ($this.attr("step") && $this.attr("step") !== "") $80ac2f7228d39a43$var$InputNumber.var.step = parseFloat($this.attr("step"));
            $this.wrapAll($inputWrapper);
            var $parent = $this.parent();
            $parent.append($plus);
            $parent.append($minus);
            $plus.on("click", function() {
                $80ac2f7228d39a43$var$InputNumber.increase($this);
            });
            $minus.on("click", function() {
                $80ac2f7228d39a43$var$InputNumber.decrease($this);
            });
        };
        for(var index = 0; index < $80ac2f7228d39a43$var$$('.quantity input[type="number"]').length; index++)_loop(index);
    },
    init: function init() {
        $80ac2f7228d39a43$var$InputNumber.makeDom();
        $80ac2f7228d39a43$var$$("body").on("updated_wc_div", function() {
            $80ac2f7228d39a43$var$InputNumber.makeDom();
        });
    }
};
var $80ac2f7228d39a43$export$2e2bcd8739ae039 = $80ac2f7228d39a43$var$InputNumber;


var $f0af294782c96cd9$var$$ = jQuery;
var $f0af294782c96cd9$var$Dots = {
    init: function init() {
        var selectValue = document.querySelector(".orderby").value;
        var select = document.querySelector(".woocommerce-ordering");
        if (select && selectValue.length > 4) {
            var html = "<span class=dots>...<span>";
            var dots = document.createElement("div");
            dots.innerHTML = html;
            select.appendChild(dots.firstChild);
        }
    }
};
var $f0af294782c96cd9$export$2e2bcd8739ae039 = $f0af294782c96cd9$var$Dots;


(0, $e27b66a2e97b0703$export$2e2bcd8739ae039).init();
(0, $ebcfa5bf42516135$export$2e2bcd8739ae039).init();
(0, $8abcc1088efdfbad$export$2e2bcd8739ae039).init();
(0, $5212bc5a3ed6c991$export$2e2bcd8739ae039).init();
(0, $1c60fdd7aa1191e5$export$2e2bcd8739ae039).init();
(0, $3bf4470344899cf3$export$2e2bcd8739ae039).init();
(0, $80ac2f7228d39a43$export$2e2bcd8739ae039).init();
(0, $f0af294782c96cd9$export$2e2bcd8739ae039).init();

})();
//# sourceMappingURL=main.js.map
